/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { resetFilters, setFilter, setPagination } from "..";

type FilterKeys =
  | "state"
  | "tip"
  | "initial_term"
  | "final_term"
  | "meta"
  | "created_at";

export const useFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilter = (key: FilterKeys, value: any) => {
    dispatch(setFilter({ key, value }));
  };

  const clearFilters = () => {
    dispatch(resetFilters());
  };

  const updatePagination = (page: number, perPage: number) => {
    dispatch(setPagination({ page, perPage }));
  };

  return { updateFilter, clearFilters, updatePagination };
};
